import React, {useLayoutEffect, useRef} from "react";
import PropTypes from "prop-types";
import "./style.scss";

export default function BaseTextArea({
  id,
  name,
  placeholder,
  required,
  autofocus,
  cols,
  disabled,
  maxlength,
  row,
  wrap,
  className,
  minLength,
  onChange,
  errorMessage,
  value,
  autoResize,
}) {
  BaseTextArea.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    errorMessage: PropTypes.string,
    autofocus: PropTypes.string,
    cols: PropTypes.number,
    row: PropTypes.number,
    minLength: PropTypes.number,
    maxlength: PropTypes.number,
    disabled: PropTypes.string,
    wrap: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    autoResize: PropTypes.bool,
  };

  const cls = ["base-textarea"];
  if (className) cls.push(className);
  const isError = (errorMessage && errorMessage.trim() !== "") || false;

  const textbox = useRef(null);

  function adjustHeight() {
    textbox.current.style.height = "inherit";
    textbox.current.style.height = `${textbox.current.scrollHeight}px`;
  }

  function handleKeyDown(e) {
    if (autoResize) adjustHeight();
  }

  const handleOnChange = (e) => {
    if (autoResize) handleKeyDown(e);
    onChange(e);
  };

  useLayoutEffect(adjustHeight, []);

  return (
    <div className="base-textarea-wrapper">
      <textarea
        ref={textbox}
        id={id || "textarea-target"}
        className={cls.join(" ")}
        name={name}
        cols={cols}
        rows={row}
        value={value}
        wrap={wrap}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autofocus}
        maxLength={maxlength}
        minLength={minLength}
        onChange={handleOnChange}
      />
      <div
        className={`base-input__hint ${isError && "base-input__hint_error"}`}
      >
        {errorMessage || ""}
      </div>
    </div>
  );
}
